var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "section-wrapper", attrs: { id: _vm.id } },
    [
      _c(
        "div",
        {
          staticClass: "section-range",
          class: { "section-range--active": _vm.withRange }
        },
        [
          _c(
            "div",
            {
              staticClass: "section-background",
              style: { "background-color": _vm.backgroundColor }
            },
            [
              _c("div", { staticClass: "section-background__effects" }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "section-background__foreground" },
                [
                  _vm.child
                    ? _c(_vm.getComponentVue(_vm.child.id), {
                        tag: "component",
                        attrs: { id: _vm.child.id }
                      })
                    : _vm._e()
                ],
                1
              )
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "section-menu" }, [
            _c("div", { staticClass: "section-buttons" }, [
              _c(
                "div",
                {
                  staticClass:
                    "section-buttons__button section-buttons__button--colorPicker tooltip-edit-background",
                  on: {
                    click: _vm.clickedColorPickerIcon,
                    mouseover: _vm.showRange,
                    mouseout: _vm.hideRange
                  }
                },
                [
                  _c("span", {
                    staticClass: "colorPickerIcon fi-paint-bucket"
                  }),
                  _vm._v(" "),
                  _c("el-color-picker", {
                    directives: [
                      {
                        name: "click-document",
                        rawName: "v-click-document",
                        value: _vm.closeColorPicker,
                        expression: "closeColorPicker"
                      }
                    ],
                    staticClass: "colorPicker",
                    attrs: {
                      size: "small",
                      "color-format": "rgb",
                      predefine: _vm.predefineColors
                    },
                    on: {
                      change: _vm.submitColor,
                      "active-change": _vm.activeColor
                    },
                    model: {
                      value: _vm.backgroundColor,
                      callback: function($$v) {
                        _vm.backgroundColor = $$v
                      },
                      expression: "backgroundColor"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "section-buttons__button section-buttons__button--delete tooltip-delete-section",
                  on: {
                    mouseover: _vm.showRange,
                    mouseout: _vm.hideRange,
                    click: function($event) {
                      _vm.deleteComponent()
                    }
                  }
                },
                [_c("span", { staticClass: "fi-trash" })]
              )
            ]),
            _vm._v(" "),
            _vm._m(0)
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "section-handle tooltip-drag-handle" }, [
      _c("div", { staticClass: "section-handle__icon" }, [
        _c("span", { staticClass: "fi-braille" })
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }